var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 21.75V23H0.75V21.75L3.25 19.25V11.75C3.25 7.875 5.7875 4.4625 9.5 3.3625V3C9.5 2.33696 9.76339 1.70107 10.2322 1.23223C10.7011 0.763392 11.337 0.5 12 0.5C12.663 0.5 13.2989 0.763392 13.7678 1.23223C14.2366 1.70107 14.5 2.33696 14.5 3V3.3625C18.2125 4.4625 20.75 7.875 20.75 11.75V19.25L23.25 21.75ZM14.5 24.25C14.5 24.913 14.2366 25.5489 13.7678 26.0178C13.2989 26.4866 12.663 26.75 12 26.75C11.337 26.75 10.7011 26.4866 10.2322 26.0178C9.76339 25.5489 9.5 24.913 9.5 24.25",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0a44dcd1dbbc55ac6f5481b351a8a322.svg";
export { ForwardRef as ReactComponent };